import { queryClient } from "@/utils/api";
import { toISODateString } from "@/utils/dates";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";

const paramsSchema = z.object({
  weekStart: z.iso.date().transform((string) => new Date(string)),
});

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart",
)({
  params: {
    parse: paramsSchema.parse,
    stringify: (params) => ({
      ...params,
      weekStart: toISODateString(params.weekStart),
    }),
  },
  beforeLoad: async ({ context }) => {
    const campaign = await queryClient.ensureQueryData(
      context.campaignQueryOptions,
    );

    if (campaign.type !== "Scheduled" || context.trialPeriod)
      throw redirect({ from: Route.fullPath, to: "../.." });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
